export default __webpack_public_path__ + "static/media/S-020.7a61f068.png";